import React from "react";
import styled from "styled-components";
import logo from "../logo.png";

const LogoImg = styled.img`
  display: block;
  margin: 0 auto;
  margin-top: -15px;
`;

export default function Logo() {
  return <LogoImg src={logo} alt="Logo" width="300px" />;
}
